<template>
  <div>
    <v-card style="border-top-right-radius: 20px" class="mt-2" outlined tile>
      <perfect-scrollbar style="max-height: 675px">
        <v-data-table
          class="fs-table-pedidos"
          :loading="loading"
          loading-text="Carregando pedidos, aguarde..."
          :headers="headers"
          v-model="$store.state.pedidos.pedidosSelecionados"
          :items="data.data"
          :items-per-page="limit"
          :sort-desc="sortDesc"
          hide-default-footer
          hide-action
          show-select
          sort-by="id"
          item-key="id"
        >
          <template v-slot:body="{ items }">
            <tr id="fs-pedidos-row" :class="colorirRow(item)" v-for="item in items" :key="item.id">
              <td>
                <v-checkbox
                  color="#2A2F50"
                  v-model="$store.state.pedidos.pedidosSelecionados"
                  :value="item"
                  style="margin:0px; padding:0px"
                  hide-details
                />
              </td>
              <td @click="selectItem(item)" style="width: 105px !important">
                <v-tooltip v-if="item.vendedor" right>
                  <template v-slot:activator="{ on }">
                    <v-img v-if="item.vendedor.foto_url" v-on="on" class="fs-miniatura" :src="item.vendedor.foto_url"></v-img>
                    <v-img v-else v-on="on" class="fs-miniatura" :src="require('@/assets/semfoto.png')"></v-img>
                  </template>
                  <span style="font-size: 11px">{{ item.vendedor.nome }}</span>
                </v-tooltip>
              </td>
              <td @click="selectItem(item)">
                <div>
                  <b>{{ item.id.padStart(7, '0') }}</b> |
                  <span v-if="item.valor_total">
                    <b>{{ formatarMoeda(item.valor_total, 2) }}</b>
                  </span>
                  <span v-if="!item.valor_total">
                    <b>SEM ITENS</b>
                  </span>
                </div>
                <div>{{ formatarData(item.created_at) }}</div>
                <div>{{ formatarData(item.updated_at) }}</div>
              </td>
              <td>
                <span v-for="(produto, index) in item.itens" :key="index">
                  <img
                    v-if="index < 2"
                    :src="URL_SITE + produto.ecommercegrupo.url_miniatura_grupo"
                    @click="itemMostrarDetalhes = item; dialogDetalhes = true; tab = 'tab-2'"
                    alt="miniatura_do_produto"
                    class="fs-miniatura mr-2"
                  >
                  <span v-else>
                    ...
                  </span>
                </span>
                <span v-if="item.itens.length === 0">
                  <img
                    @click="itemMostrarDetalhes = item; dialogDetalhes = true; tab = 'tab-2'"
                    :src="require('@/assets/cart-empty.jpg')"
                    alt="miniatura_do_produto"
                    class="fs-miniatura mr-2">
                </span>
              </td>
              <td @click="selectItem(item)">
                <v-chip
                  style="background-color: white !important"
                  class="fs-chip-fase"
                  :color="item.fase.cor_fase"
                  outlined
                >
                  {{ item.fase.nome_fase }}
                </v-chip>
              </td>
              <td @click="selectItem(item)">
                <div>{{ item.cnpj }}</div>
                <div><b>{{ item.nome }}</b></div>
                <div>{{ item.contato }}</div>
              </td>
              <td @click="selectItem(item)">
                <div>{{ item.telefone }}</div>
                <div>{{ item.whatsapp }}</div>
                <div>{{ item.email }}</div>
              </td>
              <td @click="selectItem(item)" style="text-align: center">
                <img class="ml-n5" style="width: 33px" :src="require(`@/assets/temp${item.emotion}.svg`)">
              </td>
              <td @click="selectItem(item)" style="text-align: center">
                <v-icon
                  v-if="item.confirmado === 'S'"
                  class="ml-n5"
                  style="color: green; font-size: 35px !important">
                  mdi-checkbox-marked-circle
                </v-icon>
              </td>
              <td class="fs-align-center">
                <v-btn small @click="itemMostrarDetalhes = item; dialogDetalhes = true; tab = 'tab-1'" icon>
                  <v-icon class="fs-icons-acoes">mdi-open-in-new</v-icon>
                </v-btn>
                <v-btn small @click="itemMostrarDetalhes = item; dialogDetalhes = true; tab = 'tab-3'" icon>
                  <v-icon class="fs-icons-acoes">mdi-message-text</v-icon>
                </v-btn>
                <!-- BTN ALERTAS -->
                <v-btn v-if="!verificarAlertasPendentes(item.alertas)" small @click="itemMostrarDetalhes = item; dialogDetalhes = true; tab = 'tab-4'" icon>
                  <v-icon class="fs-icons-acoes">mdi-bell</v-icon>
                </v-btn>
                <v-btn v-else class="ml-n1" @click="itemMostrarDetalhes = item; dialogDetalhes = true; tab = 'tab-4'" small icon>
                  <v-badge color="white" style="width: 27px;" overlap>
                    <template v-slot:badge>
                      <span class="fs-badge-alerta-grid">{{ verificarAlertasPendentes(item.alertas) }}</span>
                    </template>
                    <v-icon>mdi-bell</v-icon>
                  </v-badge>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </perfect-scrollbar>

      <!-- DIALOG DETALHES -->
      <v-dialog v-model="dialogDetalhes" max-width="1000px">
        <detalhespedido v-if="dialogDetalhes" :itemMostrarDetalhes="itemMostrarDetalhes" :fecharDetalhes="fecharDialog" :tabInicial="tab"></detalhespedido>
      </v-dialog>

      <!-- FOOTER -->
      <v-row class="ml-4 mr-6 my-3" no-gutters>
        <v-col cols="12">
          <v-row align="center" justify="space-between">
            <v-card class="ml-3" flat>
              <v-btn-toggle
                v-model="limit"
                mandatory
                group
                dense
              >
                <v-btn :value="10" class="fs-btn-limit">10</v-btn>
                <v-btn :value="15" class="fs-btn-limit">15</v-btn>
                <v-btn :value="20" class="fs-btn-limit">20</v-btn>
                <v-btn :value="50" class="fs-btn-limit">50</v-btn>
                <v-btn :value="100" class="fs-btn-limit">100</v-btn>
              </v-btn-toggle>
            </v-card>
            <v-card flat>
              <v-pagination color="#2A2F50" v-model="page" :length="data.lastPage" circle total-visible="8"></v-pagination>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import moment from 'moment'
export default {
  components: {
    detalhespedido: () => import('@/views/app/crm/listagemdepedidos/tablepedidos/dialogdetalhes')
  },
  data: () => ({
    URL_SITE: 'https://fortkol.com.br',
    selecao: [],
    headers: [
      { text: 'VENDEDOR', value: 'vendedor.nome' },
      { text: 'ID', value: 'id' },
      { text: 'PRODUTOS' },
      { text: 'FASE', value: 'fase_id' },
      { text: 'DADOS DO CLIENTE', value: 'cnpj', sortable: false },
      { text: 'CONTATOS', value: 'cnpj', sortable: false },
      { text: 'TEMPERATURA', value: 'emotion', align: 'center' },
      { text: 'CONFIRMADO', value: 'confirmado', align: 'center' },
      { text: 'AÇÕES', sortable: false, align: 'center' }
    ],
    tab: null,
    itemMostrarDetalhes: null,
    dialogDetalhes: false,
    sortBy: 'id',
    sortDesc: true,
    page: 1,
    limit: 10
  }),
  mounted () {
    // this.carregarDados()
  },
  watch: {
    page: function () {
      this.getDataFromApi()
    },
    limit: function () {
      this.page = 1
      this.getDataFromApi()
    },
    dialogDetalhes: function (value) {
      if (!value) this.tab = null
    }
  },
  computed: {
    ...mapState({
      data: state => state.pedidos.pedidos,
      filtroAtual: state => state.pedidos.filtroAtual,
      selecionados: state => state.pedidos.pedidosSelecionados,
      loading: state => state.pedidos.loading
    })
  },
  methods: {
    ...mapMutations({
      setPedidosSelecionados: 'pedidos/SETPEDIDOSSELECIONADOS'
    }),
    ...mapActions({
      loadPedidos: 'pedidos/loadPedidos',
      loadPedidosFiltro: 'pedidos/loadPedidosFiltro'
    }),
    carregarDados () {
      this.getDataFromApi()
    },
    verificarAlertasPendentes (alertas) {
      if (alertas.length) {
        let n = 0
        for (const item of alertas) {
          const notifs = item.notificacoes
          for (const item of notifs) {
            if (item.vista === 'N') n = n + 1
          }
        }
        return n
      }
    },
    formatarData (data) {
      // console.log(moment(data).format('L LT'))
      return moment(data).format('DD/MM/YYYY HH:mm')
      // return data
    },
    formatarMoeda (number, digits) {
      number = parseFloat(number).toFixed(digits)
      number = number.toString()
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(number)) { number = number.replace(pattern, '$1,$2') }
      return 'R$ ' + number
    },
    colorirRow (item) {
      let bgColor = ''
      if (item.feedback_comportamento === '01') {
        bgColor = 'fs-fundo-verde'
      } else if (item.feedback_comportamento === '02') {
        bgColor = 'fs-fundo-azul'
      } else if (item.feedback_comportamento === '03') {
        bgColor = 'fs-fundo-vermelho'
      }
      return bgColor + this.isActive(item)
    },
    async getDataFromApi () {
      if (this.filtroAtual) {
        await this.loadPedidosFiltro({ filtro: this.filtroAtual, pagination: { page: this.page, limit: this.limit } })
      }
    },
    fecharDialog () {
      this.dialogDetalhes = false
    },
    isActive (row) {
      if (this.selecionados.find(item => { return item === row })) return ' tr-selecionada'
      return ' tr-normal'
    },
    selectItem (value) {
      const aux = this.selecionados
      if (aux.find(item => { return item === value })) {
        const index = aux.indexOf(value)
        aux.splice(index, 1)
        this.setPedidosSelecionados(aux)
      } else {
        aux.push(value)
        this.setPedidosSelecionados(aux)
      }
    }
  }
}
</script>

<style scoped>
  #fs-pedidos-row {
    border-bottom: 1px solid rgba(0,0,0,.12);
  }
  .tr-selecionada {
    border-left: 20px solid #2A2F50;
    transition: .3s;
    box-shadow: inset 0 0 .4em rgba(15, 15, 15, 0.233);
    border-bottom: 1px solid rgba(37, 37, 37, 0.267) !important;
  }
  .tr-normal {
    transition: .3s;
    border-left: 1px solid rgba(0, 0, 0, 0);
  }
  thead:hover > tr {
    transform: scaleX(1) !important;
  }
  .fs-miniatura {
    border: 1px solid rgba(214, 214, 214, 0.5);
    width: 50px !important;
    height: 50px !important;
    border-radius: 50px;
    margin: 4px 0px 4px 4px !important;
  }
  .fs-miniatura:hover {
    border: 1px solid rgba(156, 156, 156, 0.527);
    cursor: pointer;
  }
  /* REMOVE AS BORDAS AZUIS HORRIVEIS QUANDO CLICA */
  textarea:focus, input:focus, select:focus, button:focus {
    box-shadow: 0 0 0 0;
    border: 0;
    outline: 0;
  }
  .fs-btn-limit {
    font-size: 11px !important;
  }
  .v-input--selection-controls__ripple {
    width: 30px;
    height: 30px;
    margin: 8px 0px 0px 7px;
  }
  .v-tab {
    border-left: 1px solid #FAFAFA;
    font-size: 12px;
  }
  .fs-tab-active-class {
    background-color: #FAFAFA !important;
  }
  .fs-chip-fase {
    cursor: pointer;
    font-size: 11.5px !important;
  }
  .fs-fundo-verde {
    background-color: rgba(128, 231, 96, 0.1);
  }
  .fs-fundo-azul {
    background-color: rgba(116, 160, 241, 0.1);
  }
  .fs-fundo-vermelho {
    background-color: rgba(241, 116, 116, 0.1);
  }
  .fs-align-center {
    text-align: center;
  }
  .fs-div-numeropedido {
    opacity: 0.8;
    position: absolute !important;
    right: 20px;
    top: 20px;
    font-size: 13px;
  }
  .fs-badge-alerta-grid {
    font-size: 10px;
    background-color: red;
    border-radius: 50%;
    padding: 0px 4px 0px 4px;
  }
</style>

<style scoped>
  tr:hover {
    transition: .2s;
    cursor: pointer;
    transform: scaleX(0.99);
    box-shadow: .2em .25em .1em .0em rgba(15, 15, 15, 0.233);
  }
</style>
